import React, { FC } from 'react';
import { useField as useFormikField } from 'formik';
import { DatePickerInput } from 'wix-ui-tpa/DatePickerInput';
import { useTranslation, useEnvironment } from '@wix/yoshi-flow-editor';

import { classes } from './DatePicker.st.css';
import { Field, FieldWrapper } from '../../../../../../types';
import { FieldLabel } from '../../FieldLabel';
import { FieldPrivacyIcon } from '../../FieldPrivacyIcon';
import { getFieldLabel } from '../utils/getFieldLabel';

const getISO8601Date = (date: Date) => date.toISOString().substring(0, 10);

interface DatePickerProps extends FieldWrapper {
  allowFutureDates?: boolean;
}

export const DatePicker: FC<DatePickerProps> = ({
  theme,
  formikFieldSelector,
  allowFutureDates = true,
}) => {
  const [formikField, , helpers] = useFormikField<Field>(formikFieldSelector);
  const { t } = useTranslation();
  const { multilingual } = useEnvironment();
  const field = formikField.value;
  const { required, infoTooltipText, value, id } = field;

  return (
    <div className={classes.root}>
      <FieldLabel
        htmlFor={id}
        text={getFieldLabel(t, field, multilingual.isEnabled)}
        isFieldRequired={required}
        infoTooltipText={infoTooltipText}
      />
      <FieldPrivacyIcon formikFieldSelector={formikFieldSelector}>
        <DatePickerInput
          value={value && new Date(value)}
          className={classes.field}
          inputTheme={theme}
          showMonthDropdown
          showYearDropdown
          inputWidth="100%"
          filterDate={
            allowFutureDates ? undefined : (date) => date < new Date()
          }
          onChange={(newDate: Date) => {
            helpers.setValue({
              ...field,
              value: newDate && getISO8601Date(newDate),
            });
          }}
        />
      </FieldPrivacyIcon>
    </div>
  );
};
